/*
 * Copyright (c) 2023 Roboto Technologies, Inc.
 */

/**
 * Mirrors the backend's Fargate customer rates (roboto_internal.metering.compute_credits): 5 credits
 * per dollar of AWS Fargate list price (roboto_internal.metering.provider_costs, us-west-2 x86). Keep
 * the two in step.
 */
const CREDITS_PER_USD = 5;
export const FARGATE_VCPU_USD_PER_HOUR = 0.04048;
export const FARGATE_RAM_GB_USD_PER_HOUR = 0.004445;
const FARGATE_STORAGE_GB_USD_PER_HOUR = 0.000111;
const FREE_STORAGE_GB = 20;

const VCPU_PER_HOUR = CREDITS_PER_USD * FARGATE_VCPU_USD_PER_HOUR;
const ONE_vCPU = 1024;
const RAM_GB_PER_HOUR = CREDITS_PER_USD * FARGATE_RAM_GB_USD_PER_HOUR;
const ONE_GiB_RAM = 1024;
const SSD_GB_PER_HOUR = CREDITS_PER_USD * FARGATE_STORAGE_GB_USD_PER_HOUR;

export const creditsPerHour = (
  vcpus: number,
  memoryMb: number,
  storageGb: number,
): number => {
  const vcpu_contribution = VCPU_PER_HOUR * (vcpus / ONE_vCPU);
  const ram_contribution = RAM_GB_PER_HOUR * (memoryMb / ONE_GiB_RAM);
  const ssd_contribution =
    SSD_GB_PER_HOUR * Math.max(0, storageGb - FREE_STORAGE_GB);

  return vcpu_contribution + ram_contribution + ssd_contribution;
};
